import Helmet from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { getPageStatus, PageLayout } from 'components/PageLayout';
import { useNotificationsSettings } from 'features/notifications/hooks/useNotificationsSettings';
import { NotificationsSubscriptionsEditor } from 'features/notifications/components/NotificationsSubscriptionsEditor';
import { useWeatherAlertList } from 'features/weatherAlerts/hooks/useWeatherAlertList';
import { useLocation } from 'react-router-dom';
import { TurnOnNotificationsDownState } from './TurnOnNotificationsDownState';

export const Content = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('notifications.notifications')}</title>
      </Helmet>
      <NotificationsSubscriptionsEditor />
    </>
  );
};

export const NotificationSettings = (): JSX.Element => {
  const { t } = useTranslation();
  const { isPushEnabled, pushToken } = useNotificationsSettings();
  const location = useLocation<{ fromRoute?: string }>();

  // Fetch weather alerts as soon as the page loads
  useWeatherAlertList();

  const returnRoute = location.state?.fromRoute || '/';

  // add `&& false` for local dev
  const status = getPageStatus({ isLoading: isPushEnabled && !pushToken });

  return (
    <PageLayout
      status={status}
      headerBarProps={{
        action: returnRoute,
        title: t('notifications.notifications'),
      }}
    >
      {isPushEnabled ? <Content /> : <TurnOnNotificationsDownState />}
    </PageLayout>
  );
};
